// ReportsPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const ReportsPage = () => <ComingSoon title="Reports" description="Reports are on the way. Reservation Reports and Financial Reports are available now." />;

export default ReportsPage;
